'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Bugsnag = exports.Bugsnag = function () {
  function Bugsnag() {
    _classCallCheck(this, Bugsnag);
  }

  _createClass(Bugsnag, null, [{
    key: 'inject',
    value: function inject() {
      var script = document.createElement('script');
      script.src = '//d2wy8f7a9ursnm.cloudfront.net/v4/bugsnag.min.js';
      document.getElementsByTagName('head')[0].appendChild(script);
      return script;
    }
  }, {
    key: 'initialize',
    value: function initialize(apiKey, userId, releaseStage) {
      var _this = this;

      if (window.bugsnagClient === undefined) {
        var script = Bugsnag.inject();
        script.addEventListener('load', function () {
          _this._bugsnagClient = window.bugsnag({
            apiKey: apiKey,
            releaseStage: releaseStage,
            user: {
              id: userId
            }
          });
          window.bugsnagClient = _this._bugsnagClient;
        });
      }
    }
  }]);

  return Bugsnag;
}();